import { Switch } from "@mui/material";
import React from "react";
import { TaskTypeClassVertical } from "ui/Scripts/source/models/enums";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";

interface IFormDesignerComponentPropertiesVerticalProps {
    taskTypeCol?: ITaskTypeCol;
    onChange?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

const getChecked = (classes: string) => {
    return classes.includes(" " + TaskTypeClassVertical.Yes + " ");
};

export const FormDesignerComponentPropertiesVertical = (
    props: IFormDesignerComponentPropertiesVerticalProps
) => {
    //NOTE: class name may be used in other style class as prefix or suffix => need to use padding (problem: sText <=> sTextArea)
    const classes = " " + (props.taskTypeCol?.class ?? "") + " ";

    const handleChange = (e: any, aChecked: boolean) => {
        props.onChange([{
            field: props.taskTypeCol?.field,
            name: "class",
            value: classes
                .replace(" " + TaskTypeClassVertical.Yes + " ", " ").trim() +
                (aChecked ? " " + TaskTypeClassVertical.Yes : "")
        }]);
    };

    const checked = getChecked(classes);

    return (
        <Switch
            checked={checked}
            onChange={handleChange}
        />
    );
};
